module.exports = __webpack_public_path__ + "img/curso-p.8adc1cd1.png";